// removed by extract-text-webpack-plugin
module.exports = {"selectPackagePage":"_1VBd8qWuBUCtpWg3oGJ5Rp"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/containers/SelectPackagePage.scss
// module id = 1573
// module chunks = 0